"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getDataUrlFromFile = require("./getDataUrlFromFile");
Object.keys(_getDataUrlFromFile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDataUrlFromFile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getDataUrlFromFile[key];
    }
  });
});